import { FormDetail } from './form-detail';
// import pc from './pc';
// import mobile from './mobile';
export { FormDetail, };
